import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { Button, Modal, Space, Table, Select, Input, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Createseller from "./components/Createseller";
import Editseller from "./components/Editseller";
import { deleteItem, readUsers, readRoles, readItems } from "@directus/sdk";
import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";

const { Option } = Select;

const Sellers = (props) => {
  const [datasellers, setDatasellers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [opencreate, setOpencreate] = useState(false);
  const [openupdate, setOpenupdate] = useState(false);
  const [selectseller, setSelectseller] = useState({});
  const [bodegas, setBodegas] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const [nameFilter, setNameFilter] = useState("");
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Rol",
      dataIndex: "role.name",
      key: "role.name",
      render: (_, record) => {
        return record.role.name;
      },
    },
    {
      title: "Documento",
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: "Bodega",
      dataIndex: "bodega.nombre",
      key: "bodega.nombre",
      render: (_, record) => {
        return record.bodega ? record.bodega.nombre : "Sin bodega";
      },
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("directus_users", "delete", permisos) && (
            <Button
              onClick={async () => {
                const directus = await getDirectusClient();
                Modal.confirm({
                  title: "Eliminar usuario",
                  icon: <ExclamationCircleFilled />,
                  content: "¿Desea eliminar este usuario?",
                  onOk() {
                    directus
                      .request(deleteItem("directus_users", record.id))
                      .then(() => getSellers());
                  },
                });
              }}
            >
              Eliminar
            </Button>
          )}
          {validarpermiso("directus_users", "update", permisos) && (
            <Button
              onClick={() => {
                setSelectseller(record);
                setOpenupdate(true);
              }}
            >
              Editar
            </Button>
          )}
        </Space>
      ),
    },
  ];

  const getRoles = async () => {
    const directus = await getDirectusClient();
    directus
      .request(
        readRoles({
          fields: ["id", "name"],
          filter: {
            name: {
              _neq: "clientes",
            },
          },
        })
      )
      .then((res) => {
        setRoles(res);
      })
      .catch((err) => console.log(err));
  };

  const getBodegas = async () => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  id: { _eq: userBodega },
                }
              : {}),
          },
          sort: ["nombre"],
        })
      );
      setBodegas(response);
    } catch (err) {
      console.error("Error fetching bodegas:", err);
    }
  };

  const getSellers = async () => {
    if (!validarpermiso("directus_users", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    const directus = await getDirectusClient();
    const filter = {
      _and: [
        selectedRole ? { role: { id: { _eq: selectedRole } } } : {},
        selectedBodega ? { bodega: { id: { _eq: selectedBodega } } } : {},
        nameFilter
          ? {
              _or: [
                {
                  first_name: {
                    _icontains: nameFilter, // Changed to case-insensitive contains
                  },
                },
                {
                  last_name: {
                    _icontains: nameFilter, // Changed to case-insensitive contains
                  },
                },
              ],
            }
          : {},
      ],
      ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
        ? {
            bodega: {
              id: { _eq: userBodega },
            },
          }
        : {}),
    };

    try {
      const res = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "role.name",
            "last_name",
            "email",
            "documento",
            "role.id",
            "superior.id",
            "bodega.id",
            "bodega.nombre",
          ],
          filter: filter,
        })
      );
      setDatasellers(res.filter((user) => user.role.name !== "clientes"));
      setHasPermissionError(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      if (
        error.response?.status === 403 ||
        error.message?.includes("permission")
      ) {
        setHasPermissionError(true);
        message.error("No tiene permisos para ver los usuarios");
      } else {
        Modal.error({
          title: "Error",
          content: "Error al obtener los usuarios",
        });
      }
    }
  };

  useEffect(() => {
    getRoles();
    getBodegas();
    getSellers();
  }, []);

  useEffect(() => {
    getSellers();
  }, [selectedRole, selectedBodega, nameFilter]);

  const closeCreate = () => {
    setOpencreate(false);
  };

  const closeUpdate = () => {
    setOpenupdate(false);
  };

  return (
    <Layouts>
      {!hasPermissionError ? (
        <>
          <h3>Usuarios y clientes</h3>
          <Space
            direction="vertical"
            style={{ width: "100%", marginBottom: 16 }}
          >
            <Space>
              {validarpermiso("directus_users", "create", permisos) && (
                <Button
                  onClick={() => setOpencreate(true)}
                  disabled={hasPermissionError}
                >
                  Crear usuario o cliente
                </Button>
              )}
              <Input.Search
                placeholder="Buscar por nombre"
                style={{ width: 200 }}
                onSearch={(value) => setNameFilter(value)}
                allowClear
                disabled={hasPermissionError}
              />
              <Select
                style={{ width: 200 }}
                placeholder="Filtrar por rol"
                allowClear
                onChange={(value) => setSelectedRole(value)}
                disabled={hasPermissionError}
              >
                <Option value={null}>Todos los roles</Option>
                {roles.map((role) => (
                  <Option key={role.id} value={role.id}>
                    {role.name}
                  </Option>
                ))}
              </Select>
              <Select
                style={{ width: 200 }}
                placeholder="Filtrar por bodega"
                allowClear
                onChange={(value) => setSelectedBodega(value)}
                disabled={hasPermissionError}
              >
                <Option value={null}>Todas las bodegas</Option>
                {bodegas.map((bodega) => (
                  <Option key={bodega.id} value={bodega.id}>
                    {bodega.nombre}
                  </Option>
                ))}
              </Select>
            </Space>
          </Space>

          <Table columns={columns} dataSource={datasellers} rowKey="id" />

          {validarpermiso("directus_users", "create", permisos) && (
            <Createseller
              getSellers={getSellers}
              opencreate={opencreate}
              closeCreate={closeCreate}
              permisos={permisos}
            />
          )}

          {openupdate &&
            selectseller &&
            validarpermiso("directus_users", "update", permisos) && (
              <Editseller
                getSellers={getSellers}
                opencreate={openupdate}
                closeUpdate={closeUpdate}
                selectseller={selectseller}
                setSelectseller={setSelectseller}
                permisos={permisos}
              />
            )}
        </>
      ) : (
        <h3>No tiene permisos para ver usuarios</h3>
      )}
    </Layouts>
  );
};

export default Sellers;
